import { styles } from "./BannerStyles";
import { Text } from "@ecco/ui/text";
import { NextImage } from "@ecco/ui/next-image";
import { Box } from "@ecco/ui/box";
import { Flex } from "@ecco/ui/flex";
import type { FC } from "react";
import type { ILink, ILinksCollection } from "@contentful-api/types/contentful";
import { Link } from "@components/cms/link/Link";
import { resolveMediaAsset } from "@lib/contentful/api/helpers/resolveMediaAsset";

interface IBannerProps {
    bannerItems: ILinksCollection["fields"]["links"];
}

const Banner: FC<IBannerProps> = ({ bannerItems }) => {
    const items = bannerItems.map((link) => {
        const categoryName = link?.fields?.label || "";
        const linkFields = (link as ILink)?.fields;
        const imageUrl = resolveMediaAsset(linkFields?.linkAsset, linkFields?.linkImage)?.url || "";
        return (
            <Link
                className="link"
                link={link}
                textDecor="none"
                sx={styles.bannerLink}
                key={link.sys.id}
            >
                <Flex direction="column" sx={styles.bannerItemContainer} maxW={["100%", "62.6vw"]}>
                    <Box sx={styles.bannerImage}>
                        <NextImage
                            objectFit="cover"
                            alt=""
                            src={imageUrl}
                            sizes={["50vw", "50vw", "50vw", "25vw"]}
                        />
                    </Box>
                    <Text sx={styles.bannerText}>{categoryName}</Text>
                </Flex>
            </Link>
        );
    });

    return items.length ? (
        <Box sx={styles.parentContainer} data-testid="productBanner">
            <Flex sx={styles.container}>{items}</Flex>
        </Box>
    ) : null;
};

export default Banner;
